<template>
  <transition name="page-move">
    <router-view class="custom-view"></router-view>
  </transition>
</template>

<script type="text/ecmascript-6">
export default {};
</script>

<style lang="less" scoped>
.page-move-enter,
.page-move-leave-active {
  transform: translate(100%, 0);
}

.page-move-enter-active,
.page-move-leave-active {
  transition: transform 0.5s;
}
</style>
